import { Element } from "@xmpp/xml"
import { Activity } from "../reducers/activitySlice"

const firstChild = (xml: Element): Element | undefined => {
  const children = xml.children.filter((e) => e instanceof Element) as Element[]
  return children[0]
}

class ActivityParser {
  static parseItem(item: Element): Activity {
    const activityNode = item.getChild(
      "activity",
      "http://jabber.org/protocol/activity",
    ) as Element

    // XEP-0108 says that the general element MUST be present.
    // That's why we cast to Element because we can be sure that it exists.
    // The secondary specifc element is optional.
    // https://xmpp.org/extensions/xep-0108.html#proto-format
    const generalNode = firstChild(activityNode) as Element
    const specificNode = firstChild(generalNode)

    return {
      jid: item.attrs.id,
      general: generalNode.name,
      specific: specificNode?.name,
    }
  }

  static parse(stanza: Element): Activity | undefined {
    const eventNode =
      stanza.getChild("event", "http://jabber.org/protocol/pubsub#event") ||
      stanza.getChild("pubsub", "http://jabber.org/protocol/pubsub")
    if (!eventNode) return

    const itemsNode = eventNode.getChildByAttr(
      "node",
      "http://jabber.org/protocol/activity",
    )
    if (!itemsNode) return

    const itemNode = itemsNode.getChildren("item")[0]
    if (!itemNode) return

    return ActivityParser.parseItem(itemNode)
  }
}

export default ActivityParser
